import { alpha, Chip, Paper, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getSiteAccent } from "../../pages/trainer/trainerUtils";

export default function TrainerSiteFilter({
  trainerSites,
  allSiteIds,
  selectedSiteIds,
  onToggleSite,
  onSelectAllSites,
}) {
  const theme = useTheme();

  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 1.5, md: 2 },
        borderRadius: 3,
        borderColor: alpha(theme.palette.divider, 0.6),
      }}
    >
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            Standorte
          </Typography>
          {trainerSites.length > 1 && (
            <Chip
              size="small"
              label="Alle"
              variant={
                selectedSiteIds.length === allSiteIds.length ? "filled" : "outlined"
              }
              color={
                selectedSiteIds.length === allSiteIds.length ? "primary" : "default"
              }
              onClick={onSelectAllSites}
              sx={{ fontWeight: 600 }}
            />
          )}
        </Stack>

        <Stack direction="row" spacing={0.75} sx={{ flexWrap: "wrap", rowGap: 0.75 }}>
          {trainerSites.map((site) => {
            const isSelected = selectedSiteIds.includes(site?._id);
            const accent = site?.accent || getSiteAccent(0);

            return (
              <Chip
                key={site?._id}
                label={site?.siteName}
                size="small"
                clickable
                onClick={() => onToggleSite(site?._id)}
                sx={{
                  fontWeight: isSelected ? 700 : 500,
                  borderColor: accent.border,
                  backgroundColor: isSelected ? accent.bg : "transparent",
                  color: isSelected ? accent.text : "text.secondary",
                  border: "1px solid",
                  "&:hover": { backgroundColor: accent.bg },
                }}
              />
            );
          })}
        </Stack>
      </Stack>
    </Paper>
  );
}
